module.exports = __webpack_public_path__ + "img/ProblemSolving.8d7bf384.svg";